import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNominasActivas } from "../../../../redux/actions/certificadoCobertura";
import { tableConfig } from "../../../commons/table/tableConfig";
import { StyledNominaContainer } from "../../../styled/Personal";

const NominaTable = ({ nominasSelected, setNominasSelected }) => {
  const dispatch = useDispatch();

  const nominasActivas = useSelector(
    (state) => state.certificadoCobertura.nominaActiva
  );

  useEffect(() => {
    if (nominasActivas.data.length === 0) {
      dispatch(getNominasActivas());
    }
  }, []);

  const columns = useMemo(() => [
    {
      accessorKey: "cuil",
      header: "CUIL",
      size: 120,
    },
    {
      accessorKey: "nombreCompleto",
      header: "Apellido, Nombre",
      size: 300,
    },
  ], []);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: nominasActivas.data || [],
    enableRowSelection: true,
    enableMultiRowSelection: true,
    enablePagination: true,
    state: {
      isLoading: nominasActivas.loading,
      rowSelection: nominasSelected
    },
    onRowSelectionChange: setNominasSelected,
    initialState: {
      ...tableConfig.initialState,
      pagination: {
        pageIndex: 0,
        pageSize: 5,
      },
    },
    paginationDisplayMode: 'pages',
    positionPagination: 'bottom',
    getRowId: (row) => row?.idNomina ? row.idNomina.toString() : "",
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10],
      labelRowsPerPage: 'Filas por página:',
    },

    layoutMode: 'grid',
    muiTableContainerProps: {
      sx: { maxHeight: '500px', width: '100%' },
    },
    muiTablePaperProps: {
      sx: { width: '100%' },
    },
  });

  return (
    <StyledNominaContainer.NominaTableContainer>
      <MaterialReactTable table={table} />
    </StyledNominaContainer.NominaTableContainer>
  );
};

export default NominaTable;
